import { UserManager } from "oidc-client-ts";
import { Service } from "./service";

interface Props {
  iframe: HTMLIFrameElement;
}

export class IframeAuthenticationService implements Service<Props, void> {
  constructor(
    private readonly window: Window,
    private readonly oidcManager: UserManager,
  ) {}

  async call({ iframe }: Props) {
    const getAccessToken = async () => (await this.oidcManager.getUser())?.access_token;
    const currentToken = await getAccessToken();
    if (currentToken === null) throw "Unexpected error";
    if (iframe.contentWindow === null) throw "Unexpected error";

    await this.waitForIframeReady(iframe);
    iframe.contentWindow.postMessage({ type: "AUTH_TOKEN", token: currentToken }, "*");
  }

  async waitForIframeReady(iframe: HTMLIFrameElement) {
    console.debug("Waiting for iframe to be ready...");
    return new Promise((resolve) => {
      this.window.addEventListener("message", (e) => this.handleMessage(e, resolve, iframe));
    });
  }

  async handleMessage(event: MessageEvent, resolve: (value: unknown) => void, iframe: HTMLIFrameElement) {
    if (event.source === iframe.contentWindow && event.data?.type === "READY_TO_GET_AUTH_TOKEN") {
      this.window.removeEventListener("message", (e) => this.handleMessage(e, resolve, iframe));
      console.debug("Iframe is ready");
      resolve(null);
    }
  }
}
